<template>
  <AlertHistory v-if="userCanSendAlerts" :useClientLayout="true" />
  <AdminLayout v-else page="Alert History" title="Alert History">
    You need permission to view this page.
  </AdminLayout>
</template>
<script lang="ts" setup>
import AlertHistory from "../staffadmin/AlertHistory.vue";
import { PermissionType } from "../../store/generatedFetchClient";
import { useUserStore } from "../../store/userStore";

// Does user have permission to send alerts
var userCanSendAlerts = computed(() =>
  useUserStore().hasPermission(PermissionType.SendAlerts)
);
</script>
